import is from 'is_js';
import * as events from 'events';
import {$events} from '../helpers/events';
import {$dom} from '../helpers/dom';

export default function initNav() {
  const {get, getAll} = $dom;
  const $navInput = get('#hum');
  const $nav = get('.nav-js');
  const $header = get('header');
  const $navLinks = getAll('.nav-link');

  const toggleNav = (checked) => {
    if (checked) {
      $nav.classList.remove('d-none')
      $header.classList.add('active')
      document.body.style.overflowY = 'hidden'
    } else {
      $nav.classList.add('d-none')
      $header.classList.remove('active')
      document.body.style.overflowY = 'auto'
    }
  }

  $navInput.addEventListener('input', (evt) => {
    toggleNav(evt.target.checked)
  })
  $navLinks.forEach(($navLink) => {
    $navLink.addEventListener('click', (evt) => {
      evt.preventDefault()
      const link = evt.target.tagName === 'A' ? evt.target : evt.target.closest('a');
      const id = link.getAttribute('href').slice(1)

      if (id) {

        const section = document.getElementById(id)
        const top = is.mobile() ? section.offsetTop - 80 : section.offsetTop - 60

        window.scrollTo({
          top,
          behavior: "smooth"
        });
        toggleNav(false)
        $navInput.checked = false;
      }

    })
  })
  $events.delegate.on('click tap', '.logo-js', function () {
    document.documentElement.setAttribute('style', 'scroll-behavior: smooth;');
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  })

  window.addEventListener('scroll', () => {
    const offset = window.pageYOffset;

    if (offset > 100) {
      $header.classList.add('scroll')
    } else {
      $header.classList.remove('scroll')
    }

  })

}
